import { useQuery } from '@/hooks/query.hook';
import { PermissionMode } from '@/enums/mode.enum';
import { AdminCreateForm } from '@/components/forms/admin-create.form';
import { AdminEditForm } from '@/components/forms/admin-edit.form';
import { AdminPermissionsTable } from '@/components/tables/admin-permissions.table';

export default function UserAdminManagement() {
  const { mode } = useQuery();

  const renderContent = () => {
    switch (mode) {
      case PermissionMode.CREATE:
        return <AdminCreateForm />;
      case PermissionMode.EDIT:
        return <AdminEditForm />;
      default:
        return <AdminPermissionsTable />;
    }
  };

  return <>{renderContent()}</>;
}
